import { ConfigProviderProps } from "antd/lib/config-provider";

export const defaultConfigProviderProps: ConfigProviderProps = {};
